/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import InputField from "../../../../components/common/new/InputField/InputField";
import Typography from "../../../../components/common/new/Typography/Typography";
import { APPOINTMENT_ENTRY } from "../../../../contants/formFields";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
import styles from "./GeneralRemark.styles";

function GeneralRemark({ values, handleChange, readOnly }) {
  const { isDistrictSi } = useSelector(selectAllSIUsers);
  return (
    <Box py="16px">
      <Box
        style={{
          borderRadius: "35px",
          background: "#196AAB",
          width: "185px",
          height: "44px",
          flexShrink: "0",
          marginBottom: "-20px",
          position: "relative",
          zIndex: "1",
          marginLeft: "45px",
        }}
      >
        <Typography
          variant="title3"
          style={{
            color: "#FFF",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "'Inter', sans-serif",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "20px",
            padding: "11px 18px 13px 17px",
            margin: "0",
          }}
        >
          General Remarks
        </Typography>
      </Box>
      <Box
        style={{
          borderRadius: "5px 5px 5px 5px",
          border: "1px solid #C2D4EB",
          background: "#F6F6F6",
          padding: "10px 20px 20px 20px",
          borderBottom: "9px solid #196AAB",
          margin: "0px 20px",
        }}
      >
        {isDistrictSi && (
          <Box
            style={{
              ...styles.paragraph,
              fontFamily: "'Inter', sans-serif",
            }}
          >
            For example: Recommending leader can share if the proposed leader
            has been attending monthly district meetings (Discussion Meeting,
            Gosho Study, DPM), works in unity, has seeking spirit, is in rhythm
            with BSG guidelines and activities etc.
          </Box>
        )}
        {!isDistrictSi && (
          <Box
            style={{
              ...styles.paragraph,
              fontFamily: "'Inter', sans-serif",
            }}
          >
            For example: recommending leader can share if the proposed leader
            has been attending various leaders meetings (DOU, DPM), works in in
            unity, has seeking spirit, is in rhythm with BSG guidelines and
            activities etc.
          </Box>
        )}
        <Box mt={6} width="100%">
          <InputField
            type="text"
            defaultValue=""
            name={APPOINTMENT_ENTRY.REMARK}
            label="Enter your remark here"
            value={values[APPOINTMENT_ENTRY.REMARK]}
            onChange={handleChange}
            InputProps={{ sx: { minHeight: "117px" } }}
            disabled={readOnly}
            style={{
              ...styles.inputStyle,
              fontFamily: "'Inter', sans-serif",
              ...(readOnly
                ? {
                    backgroundColor: "rgba(239, 239, 239, 1.5)",
                    borderRadius: 8,
                  }
                : { ...styles.inputStyle }),
            }}
          />
        </Box>
        <Box
          style={{
            ...styles.footNote,
            fontFamily: "'Inter', sans-serif",
          }}
        >
          As a general guideline, the leader being considered for appointment
          should be working in harmony with all four divisions, have an
          understanding of the spirit of mentor and disciple, be following the
          guidelines of BSG and SGI and should have family support.
        </Box>
      </Box>
    </Box>
  );
}

export default GeneralRemark;
